import { useMemo, type FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import useRoutes from './myRoutes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

interface MyRouterProps {}

const MyRouter: FC<MyRouterProps> = () => {
  const { isAuth } = useSelector((state: RootState) => state.isAuth);

  const { privateRoutes, publicRoutes } = useRoutes();

  const routes = useMemo(() => (isAuth ? privateRoutes : publicRoutes), [isAuth, privateRoutes, publicRoutes]);

  const router = useMemo(() => createBrowserRouter(routes), [routes]);

  return <RouterProvider router={router} />;
};

export default MyRouter;
